module.exports = __webpack_public_path__ + "static/img/ksfw1.8031fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/ksfw1.png
// module id = ++ft
// module chunks = 64